import { IconButton } from '@eventbrite/eds-icon-button';
import { CrossChunky as CrossChunkySvg } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { $FixMe } from '@eventbrite/ts-utils';
import isEmpty from 'lodash/isEmpty';
import React, { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
//TODO: Figure out best way to handle the "smart" behavior here
import { handleRemoveFilter as handleRemoveFilterAction } from '../../../../redux/actions/search';
import { ApiEventSearch, DiscoverState } from '../../../../types';
import { useCurrentSearchOrganicEvents } from '../../SearchPageData';
import FilterButton from './FilterButton';

type DuplicateEventsFilterButtonReduxProps = {
    eventSearch: ApiEventSearch;
    handleRemoveFilter: Function;
};

const _DuplicateEventsFilterButton = ({
    handleRemoveFilter,
    eventSearch,
}: DuplicateEventsFilterButtonReduxProps) => {
    const events = useCurrentSearchOrganicEvents(eventSearch);
    const nameOfFirstEvent = events[0]?.name || gettext('This event');
    useEffect(() => {
        // Reset the search for the user if empty state, temporary UX workaround
        if (isEmpty(events)) {
            handleRemoveFilter({ hash: true });
        }
    });

    return (
        <li className="filter-panel__drawers__item eds-l-pad-top-6 eds-l-pad-bot-5">
            <FilterButton isActive value="creditsForOrganizerFilter">
                <div>
                    <div className="filter-panel__drawers__item__sub-header">
                        {gettext('Showing events similar to')}
                    </div>
                    <div className="filter-panel__drawers__item__header">
                        {nameOfFirstEvent}
                    </div>
                </div>
            </FilterButton>
            <div className="filter-panel__drawers__item--close-btn">
                <IconButton
                    title={gettext('Remove filter')}
                    iconType={<CrossChunkySvg />}
                    iconColor="ui-blue"
                    onClick={() => handleRemoveFilter({ hash: true })}
                />
            </div>
        </li>
    );
};

const mapStateToProps = (state: DiscoverState) => {
    return {
        eventSearch: state.search.eventSearch,
    };
};

const mapDispatchToProps = (
    dispatch: (arg0: (dispatch: Function, getState: Function) => void) => any,
    ownProps: { history: object },
) => ({
    handleRemoveFilter: (...args: [$FixMe]) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
});

export const DuplicateEventsFilterButton: FunctionComponent = compose<$FixMe>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(_DuplicateEventsFilterButton);
